// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"499":"ec8320a2","540":"b3168c3e","648":"6f0ae465","710":"265d8615","884":"d8656166","961":"6c4bfc61"}[chunkId] + ".chunk.js";
};